import React from 'react';
import type { AccountInfo } from "@azure/msal-browser";

/**
 * The User type represents the MSAL account info with optional custom fields.
 * AccountInfo already includes: homeAccountId, environment, tenantId, username, localAccountId
 */
export type User = AccountInfo & {
  // Add any additional custom user properties here
  email?: string;
  name?: string;
  [key: string]: any;
};

// Create a React context for the signed-in user (or null if anonymous)
export const UserContext = React.createContext<User | null>(null);
